import { Address, ApplicationDto } from 'api/ApplicationApi';
import { HttpClient } from 'api/HttpClient';
import { BorrowerRole } from 'enums/BorrowerRole';
import { BorrowerEmploymentStatus } from 'enums/ApplicationsVariables';

export interface UpdateContractorInformationDto {
  applicationId: string;
  fundedContractorName: string;
  fundedContractorSalespersonName: string;
  fundedContractorSalespersonPhone: string;
  fundedContractorSalespersonEmail: string;
}

export interface EmploymentInformationDto {
  name: string;
  position: string;
  phone: string;
  hireDate: Date;
  address: Address;
  status?: BorrowerEmploymentStatus;
}

export interface EmploymentStatusInformationDto {
  governmentPaygrade: string;
  branchOfService: string;
  branchOfServiceRetired: string;
  militaryPaygrade: string;
  militaryPaygradeRetired: string;
  retirementDate: Date;
}

export interface UpdateEmploymentInformationDto {
  applicationId: string;
  borrowerType: BorrowerRole;
  employmentInformation?: EmploymentInformationDto[];
  previousEmploymentInformation?: EmploymentInformationDto;
  employmentStatusInformation?: EmploymentStatusInformationDto;
}

export interface MissingEmploymentInformationAddressDto {
  streetName: string;
  streetNumber?: string;
  city: string;
  stateOrProvince: string;
  zipOrPostalCode: string;
}

export interface MissingEmploymentInformationDto {
  index: number;
  name?: string;
  position?: string;
  phone?: string;
  hireDate?: Date;
  address?: MissingEmploymentInformationAddressDto;
}

export interface UpdateMissingEmploymentInformationDto {
  applicationId: string;
  borrowerType: BorrowerRole;
  employments: MissingEmploymentInformationDto[];
}

export default class EmploymentsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/employments' || '');
  }

  public async updateAdditionalContractorInformation(data: UpdateContractorInformationDto): Promise<ApplicationDto> {
    return this.instance.put('/contractor-information', data).then((response) => response.data);
  }

  public async updateAdditionalEmploymentInformation(data: UpdateEmploymentInformationDto): Promise<ApplicationDto> {
    return this.instance.put('/employment-information', data).then((response) => response.data);
  }

  public async updateMissingEmploymentInformation(
    updateMissingEmploymentInformationDto: UpdateMissingEmploymentInformationDto,
  ): Promise<ApplicationDto> {
    return this.instance
      .put('/missing-employment-information', updateMissingEmploymentInformationDto)
      .then((response) => response.data);
  }
}

export const hilEmploymentsApi = new EmploymentsApi();
